module.exports = __webpack_public_path__ + "static/media/features_pic1.b6842976.jpg";